import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        ref={ref}
        className={cn(
          "flex h-10 w-full min-w-0 rounded-full border border-black/20 bg-white px-4 py-2 font-bold text-text-primary shadow-[0_1px_2px_rgba(15,23,42,0.06)] transition-all duration-200 outline-none selection:bg-brand selection:text-text-inverse file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-lg file:font-bold file:text-text-primary placeholder:text-text-primary/40 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-40 md:text-xl dark:border-white/20 dark:bg-white/[0.07] dark:shadow-none dark:placeholder:text-white/40",
          "hover:border-black/30 dark:hover:border-white/30 dark:hover:bg-white/[0.09]",
          "focus-visible:scale-[1.01] focus-visible:border-brand/40 focus-visible:ring-4 focus-visible:ring-brand/20 dark:focus-visible:border-brand/50 dark:focus-visible:ring-brand/30",
          "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
